import { render, staticRenderFns } from "./EWFrequencyList.vue?vue&type=template&id=3368f674&"
import script from "./EWFrequencyList.vue?vue&type=script&lang=js&"
export * from "./EWFrequencyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports